import ActivityHistory from '@/containers/ActivityHistory';
import {ImageOptimization} from '@/containers/ImageOptimization';
import PropTypes from 'prop-types';
import {isObjectNotEmpty} from '@/helpers/shadcn/utils';
import {
  AddActivity,
  ActivityAttributes,
  ActivityDisplay,
  AddActivityReview,
  AddSalesTarget,
  SalesTargetDisplayContentRouter,
  AddSalesTargetProduct,
  BulkModifiersHome,
  ClubPlusHome,
  CreateBulkPointModifiers,
  CreateTier,
  DynamicTable,
  Logout,
  PageError404,
  PointMultiplier,
  ReviewBulkPointModifiers,
  ReviewPointMultiplier,
  SalesTargetHome,
  SalesTargetReview,
  TestPage,
  TierDetails,
  PerfectStoreHome,
  AddPerfectStore,
  AddPerfectStoreDisplay,
  PerfectStoreReview,
  PerfectStorePreview,
  AddPepIrisDisplay,
  PepIrisReview,
  RackChallengeDisplayContent
} from '@/pages';
import {CreateReward, RewardDetail} from '@/pages/Rewards';
import {PageError403} from '@/pages/Errors/403';
import {PageError500} from '@/pages/Errors/500';
import {
  CreatePointMultiplier,
  ProductsPointMultiplier
} from '@/pages/PointMultiplier/index';
import RewardCatalogHome from '@/pages/RewardCatalogHome';
import RackCatalogHome from '@/pages/RackCatalogHome';
import {UserDetails} from '@/services/UserDetails';
import {useAppDispatch} from '@/store';
import {setShellActive, setShellPath} from '@/store/slices/commonSlice';
import {setCountryCode} from '@/store/slices/countryCodeSlice';
import {setUserDetails} from '@/store/slices/userSlice';
import {ROUTES} from '@/utils/constants/routesConstants';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {ProtectedRoutes} from './ProtectedRoutes';

const clubPlusRoutes = [
  {path: ROUTES.CLUB_HOME, element: <ClubPlusHome />},
  {path: ROUTES.CREATE_TIER, element: <CreateTier />},
  {path: ROUTES.TIER_DETAILS, element: <TierDetails />}
];

const router = createBrowserRouter([
  {
    element: <ProtectedRoutes />,
    children: [
      {
        path: ROUTES.HOME,
        element: (
          <SalesTargetHome instanceKey='activities' selectedTab='activities' />
        )
      },
      {path: ROUTES.LOGOUT, element: <Logout />},

      {
        path: ROUTES.SALES_TARGETS,
        element: (
          <SalesTargetHome
            instanceKey='sales-target'
            selectedTab='sales-target'
          />
        )
      },
      {path: ROUTES.SALES_TARGET_ADD, element: <AddSalesTarget />},
      {
        path: ROUTES.SALES_TARGET_DISPLAY_CONTENT,
        element: <SalesTargetDisplayContentRouter />
      },
      {path: ROUTES.SALES_TARGET_PRODUCTS, element: <AddSalesTargetProduct />},
      {path: ROUTES.SALES_TARGET_REVIEW, element: <SalesTargetReview />},
      {path: ROUTES.SALES_TARGET_DETAIL, element: <SalesTargetReview />},
      {
        path: ROUTES.RACK_CHALLENGE_DISPLAY_CONTENT,
        element: <RackChallengeDisplayContent />
      },

      {path: ROUTES.PERFECT_STORE, element: <PerfectStoreHome />},
      {path: ROUTES.PERFECT_STORE_ADD, element: <AddPerfectStore />},
      {path: ROUTES.PERFECT_STORE_DISPLAY, element: <AddPerfectStoreDisplay />},
      {path: ROUTES.PERFECT_STORE_REVIEW, element: <PerfectStoreReview />},
      {path: ROUTES.PERFECT_STORE_DETAIL, element: <PerfectStorePreview />},
      {
        path: ROUTES.PERFECT_STORE_PEPIRIS_DISPLAY,
        element: <AddPepIrisDisplay />
      },
      {
        path: ROUTES.PERFECT_STORE_PEPIRIS_REVIEW,
        element: <PepIrisReview />
      },

      {
        path: ROUTES.ACTIVITIES,
        element: (
          <SalesTargetHome instanceKey='activities' selectedTab='activities' />
        )
      },
      {path: ROUTES.ACTIVITY_ADD, element: <AddActivity />},
      {path: ROUTES.ACTIVITY_ATTRIBUTES, element: <ActivityAttributes />},
      {path: ROUTES.ACTIVITY_DISPLAY, element: <ActivityDisplay />},
      {path: ROUTES.ACTIVITY_REVIEW, element: <AddActivityReview />},

      {path: ROUTES.POINT_MULTIPLIER, element: <PointMultiplier />},
      {
        path: ROUTES.POINT_MULTIPLIER_CREATE,
        element: <CreatePointMultiplier />
      },
      {
        path: ROUTES.POINT_MULTIPLIER_REVIEW,
        element: <ReviewPointMultiplier />
      },
      {path: ROUTES.POINT_MULTIPLIER_VIEW, element: <ReviewPointMultiplier />},
      {
        path: ROUTES.POINT_MULTIPLIER_PRODUCTS,
        element: <ProductsPointMultiplier />
      },

      {path: ROUTES.BULK_POINT_MODIFIERS, element: <BulkModifiersHome />},
      {
        path: ROUTES.BULK_POINT_MODIFIER_CREATE,
        element: <CreateBulkPointModifiers />
      },
      {
        path: ROUTES.BULK_POINT_MODIFIER_REVIEW,
        element: <ReviewBulkPointModifiers />
      },
      {
        path: ROUTES.BULK_POINT_MODIFIER_VIEW,
        element: <ReviewBulkPointModifiers />
      },

      {path: ROUTES.ACTIVITY_ADD, element: <AddActivity />},
      {path: ROUTES.ACTIVITY_ATTRIBUTES, element: <ActivityAttributes />},
      {path: ROUTES.ACTIVITY_DISPLAY, element: <ActivityDisplay />},
      {path: ROUTES.ACTIVITY_REVIEW, element: <AddActivityReview />},
      {path: ROUTES.ACTIVITY_VIEW, element: <AddActivityReview />},
      {path: ROUTES.TABLE, element: <DynamicTable />},

      {path: ROUTES.TABLE, element: <DynamicTable />},
      {path: ROUTES.IMAGE, element: <ImageOptimization />},
      {path: ROUTES.ADD_SALES_TARGET_DETAIL, element: <SalesTargetReview />},
      {
        path: ROUTES.PRODUCTS_POINT_MULTIPLIER,
        element: <ProductsPointMultiplier />
      },
      /* Errors */
      {path: ROUTES.ERROR_500, element: <PageError500 />},
      {path: ROUTES.ERROR_403, element: <PageError403 />},
      {path: '*', element: <PageError404 />},

      {path: ROUTES.TEST, element: <TestPage />},

      {
        path: ROUTES.RACK_CATALOG,
        element: <RackCatalogHome instanceKey='rack-catalog' />
      },
      {
        path: ROUTES.REWARD_CATALOG,
        element: <RewardCatalogHome instanceKey='reward-catalog' />
      },
      {path: ROUTES.REWARD_CATALOG_DETAIL, element: <RewardDetail />},
      {path: ROUTES.REWARDS_CREATE, element: <CreateReward />},
      /* Products */
      ...clubPlusRoutes,
      {path: ROUTES.ACTIVITY_HISTORY, element: <ActivityHistory />}
    ]
  }
]);

export const AppRouter = ({shellActive, path, market = null}) => {
  const dispatch = useAppDispatch();

  const userData = useSelector((state) => state?.userDetails);
  const getUserData = async () => {
    if (!isObjectNotEmpty(userData)) {
      try {
        await UserDetails();
        const reqData = {
          name: 'Robert',
          role: ['admin', 'super-admin'],
          country: [{name: 'Mexico', lang: [{langcode: 33, name: 'mexico'}]}],
          countryCode: 'mx',
          siteId: 21
        };
        dispatch(setUserDetails(reqData));
      } catch {
        const reqData = {
          name: 'Louis',
          role: ['admin'],
          country: [{name: 'Turkey', lang: [{langcode: 31, name: 'Turkey'}]}],
          countryCode: 'TR',
          siteId: 23
        };
        dispatch(setUserDetails(reqData));
      }
    }
  };
  useEffect(() => {
    getUserData();
  });
  useEffect(() => {
    dispatch(setShellActive(shellActive));
    if (market) {
      dispatch(setCountryCode(market));
    }
  }, [shellActive, dispatch, market]);

  // expected everytime to dispatch the shell path when component is mounted to navigate properly
  useEffect(() => {
    dispatch(setShellPath(path));
  });

  // Use market as key to force remount (refresh) when market changes
  return (
    <RouterProvider
      key={market || 'default'}
      router={router}
      future={{v7_startTransition: true}}
    />
  );
};

AppRouter.propTypes = {
  shellActive: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  market: PropTypes.string
};
